module.exports = __webpack_public_path__ + "static/img/button_digita_normal.89c3b6f4.png";